<template>
  <div>
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else>
      <div class="ticket_contact_list_header">
        <div class="d_flex_btwn">
            <div class="d_flex_start">
                <router-link :to="`/contact/${contact.id}`">
                    <button type="button" modal-target="smodal" class="btn  btn_transparent has_border_radius mr_10 d_flex_center">
                        <span class="mr_5 d_flex_center"><img src="@/assets/media/images/edit.png" alt=""></span>
                        <span class="d_flex_center no_line_height">Edit</span>
                    </button>
                </router-link>
                <router-link :to="{name: 'contacts'}" class="btn btn_black">Back to List</router-link>
            </div>

            <div class="d_flex_center">
                <div class="retail_pagination p_0 ml_15">
                    <ul>
                        <li v-if="contact.previous_contact_id">
                            <router-link :to="`/contact/${contact.previous_contact_id}/show`">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 mr-[1px] lg:w-5 lg:h-5 lg:mr-[2px]">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5"></path>
                                    </svg>
                            </router-link>
                        </li>
                        <li v-if="contact.next_contact_id">
                            <router-link :to="`/contact/${contact.next_contact_id}/show`">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 ml-[1px] lg:w-5 lg:h-5 lg:ml-[2px]">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5"></path>
                                </svg>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
      </div>
      <div class="ticket_contact_list_details_page ">
        <div class="ticket_contact_list_details_page_wrap ">
          <div class="ticket_contact_list_details_left">
              <div class="ticket_contact_list_details_left_wrap">
                  <div class="ticket_contact_list_details_table_wrap">
                      <div class="contact_details_heading_wrap">
                          <div class="contact_details_heading_inner width_full d_flex_btwn">
                              <div class="contact_details_heading">
                                  <div class="img">
                                      <img :src="contact.photo" alt="">
                                  </div>
                                  <div class="text">
                                        <h2>{{ contact.name }}</h2>
                                        <p><router-link :to="`/company/${contact.company_id}/show`">{{ contact.company?.company_name }}</router-link></p>
                                        <p>{{ contact.email }}</p>
                                  </div>
                              </div>
                          </div>
                      </div>
                          
                      
                      <div class="contact_details_content">
                          <nav class="tabs">
                              <ul class="">
                                  <li href="#tab1" :class="{'active' : activeTab == 'activityList'}" @click="activeTab = 'activityList'"> TIMELINE   </li>
                                  <li href="#tab2" :class="{'active' : activeTab == 'ticketList'}" @click="activeTab = 'ticketList'"> TICKETS  </li>
                              </ul>   
                          </nav>
                          <div class="tab_content_wrapper">
                              <div id="tab1" class="tab_content" :class="{show : activeTab === 'activityList'}">
                                  <div class="fadein">
                                      <div class="contact_details_content_wrap">
                                            <ul>
                                                <li v-for="(timelineList, timelineDate, timelineIndex) in timelines" :key="'timeline_'+timelineIndex">
                                                    <div class="time">
                                                        <span>{{ timelineDate  }}</span>
                                                    </div>
                                                    <div class="box" v-for="(timeline, index) in timelineList" :key="'single_timeline'+index">
                                                        <span></span>
                                                        <p>{{ timeline.time_formatted }}</p>
                                                        <div class="title"><router-link :to="`/ticket/${timeline.ticket_number}`">{{ timeline.subject }} # {{ timeline.ticket_number }}</router-link></div>
                                                        <div class="info"> <span class="mr_5">Status: {{ timeline.status }}</span> <span v-if="timeline.group"> Group: {{ timeline.group.name }}</span> <span v-if="timeline.user">Support User: {{ timeline.user.name }}</span> </div>
                                                        <div class="info"> 
                                                            <span v-if="timeline.closed_at_readable" class="mr_5">Closed: {{ timeline.closed_at_readable }}</span>
                                                            <span v-else-if="timeline.resolved_at_readable" class="mr_5">Resolved: {{ timeline.resolved_at_readable }}</span>
                                                            <span v-else class="mr_5">Created: {{ timeline.formatted_created_at }}</span>
                                                            <span v-if="timeline.resolution_status" class="mr_5"><span>{{ timeline.resolution_status }}</span></span>
                                                        </div>
                                                        <div class="last_update_time">
                                                            <span> <b>Last Update</b> <br> {{ timeline.updated_at }}</span>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                      </div>
                                  </div>
                              </div>
  
                              <div id="tab2" class="tab_content" :class="{show : activeTab === 'ticketList'}">
                                  <div class="fadein">
                                      <div class="contact_details_content_wrap">
                                            <div class="inner" v-for="(ticket, ticketIndex) in contact.latest_ten_tickets" :key="'ticket_'+ticketIndex">
                                                <div class="inner_wrap">
                                                    <div class="img">
                                                        <svg fill="#000000" width="34px" height="34px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>ticket</title> <path d="M22.996 10.75h-13.996c-0.69 0-1.25 0.56-1.25 1.25v0 7.605c0 0.69 0.56 1.25 1.25 1.25h13.996c0.69-0.001 1.249-0.56 1.25-1.25v-7.606c-0-0.69-0.56-1.25-1.25-1.25h-0zM21.746 18.355h-11.496v-5.105h11.496zM30 14.25c0.69-0 1.25-0.56 1.25-1.25v-5c-0-0.69-0.56-1.25-1.25-1.25h-28c-0.69 0-1.25 0.56-1.25 1.25v0 5c0 0.69 0.56 1.25 1.25 1.25v0c0.966 0 1.75 0.784 1.75 1.75s-0.784 1.75-1.75 1.75v0c-0.69 0-1.25 0.56-1.25 1.25v5c0 0.69 0.56 1.25 1.25 1.25h28c0.69-0.001 1.249-0.56 1.25-1.25v-5c-0.001-0.69-0.56-1.249-1.25-1.25h-0c-0.966 0-1.75-0.784-1.75-1.75s0.784-1.75 1.75-1.75v0zM28.75 20.041v2.709h-25.5v-2.709c1.75-0.541 3-2.145 3-4.041s-1.25-3.5-2.97-4.033l-0.030-0.008v-2.709h25.5v2.709c-1.75 0.541-3 2.145-3 4.041s1.25 3.5 2.97 4.033l0.030 0.008z"></path> </g></svg>
                                                    </div>
                                                    <div class="text">
                                                        <div class="title">
                                                            <router-link :to="`/ticket/${ticket.ticket_number}`">{{ ticket.subject }} # {{ ticket.ticket_number }}</router-link>
                                                        </div>
                                                        <div class="info"> <span class="mr_5">Status: {{ ticket.status }}</span> <span v-if="ticket.group"> Group: {{ ticket.group.name }}</span> </div>
                                                        <div class="info"> 
                                                            <span v-if="ticket.resolved_at_readable" class="mr_5">Resolved: {{ ticket.resolved_at_readable }}</span>
                                                            <span v-else-if="ticket.closed_at_readable" class="mr_5">Closed: {{ ticket.closed_at_readable }}</span>
                                                            <span v-else class="mr_5">Created: {{ ticket.formatted_created_at }}</span>
                                                            <span v-if="ticket.resolution_status" class="mr_5"><span>{{ ticket.resolution_status }}</span></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="retail_pagination d_flex_center" v-if="contact.latest_ten_tickets.length > 0 && activeTab == 'ticketList'">
                      <div class="d_flex_center">
                          <router-link  :to="{name: 'tickets', query: { contact_id : contact.id }}" class="btn  btn_transparent has_border_radius">View All Ticket</router-link>
                      </div>
                  </div>
              </div>
          </div>
          <div class="ticket_contact_list_details_right">
              <div class="ticket_contact_list_details_filter">
                  <div class="ticket_contact_list_details_filter_inner">
                      <div class="accordion_wrap">
                          <div class="accordion">
                              <div class="accordion_heading">
                                  <div class="accordion_heading_inner open" data-toggle="collapse_slide" data-target="#Card22"> 
                                      <span><svg width="15px" height="15px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="m16 0c8.836556 0 16 7.163444 16 16s-7.163444 16-16 16-16-7.163444-16-16 7.163444-16 16-16zm1.3 20.5h-2.6v2.6h2.6zm-1.3-11.5c-2.209139 0-4 1.790861-4 4h2l.0054857-.1492623c.0763492-1.0348599.9401525-1.8507377 1.9945143-1.8507377 1.1045695 0 2 .8954305 2 2s-.8954305 2-2 2h-1v4h2l.0006624-2.126188c1.7248911-.4442732 2.9993376-2.0102111 2.9993376-3.873812 0-2.209139-1.790861-4-4-4z" fill="#202327" fill-rule="evenodd"></path></g></svg></span> 
                                      <span>DETAILS</span>  
                                  </div>
                              </div>
                              <div class="accordion_body" id="Card22"  style="display: block;">
                                  <div class="t_c_details_wrap">
                                      <div class="inner" v-if="contact.description">
                                          <div class="inner_wrap">
                                              <div class="inner_content">
                                                  <h3>Description</h3>
                                                  <p v-html="contact.description"></p>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="accordion mb_0">
                              <div class="accordion_heading">
                                  <div class="accordion_heading_inner open" data-toggle="collapse_slide" data-target="#Card23">
                                      <span><svg fill="#000000" width="15px" height="15px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 92 92" enable-background="new 0 0 92 92" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path id="XMLID_1973_" d="M25,17.8V5c0-2.8,2.2-5,5-5s5,2.2,5,5v12.8c0,2.8-2.2,5-5,5S25,20.6,25,17.8z M62,22.8c2.8,0,5-2.2,5-5V5 c0-2.8-2.2-5-5-5s-5,2.2-5,5v12.8C57,20.6,59.2,22.8,62,22.8z M28.2,40h35.5c2.2,0,4-1.8,4-4s-1.8-4-4-4H28.2c-2.2,0-4,1.8-4,4 S26,40,28.2,40z M84,7h-8.3c-2.2,0-4,1.8-4,4s1.8,4,4,4H80v68H12V15h4.3c2.2,0,4-1.8,4-4s-1.8-4-4-4H8c-2.2,0-4,2.2-4,4.4V87 c0,2.2,1.8,4,4,4h76c2.2,0,4-1.8,4-4V11.4C88,9.2,86.2,7,84,7z M42.7,15h6.6c2.2,0,4-1.8,4-4s-1.8-4-4-4h-6.6c-2.2,0-4,1.8-4,4 S40.5,15,42.7,15z M28.2,58h35.5c2.2,0,4-1.8,4-4s-1.8-4-4-4H28.2c-2.2,0-4,1.8-4,4S26,58,28.2,58z"></path> </g></svg></span>
                                      <span>TO-DO</span> 
                                      </div>
                              </div>
                              <div class="accordion_body" id="Card23"  style="display: block;">
                                  <todo-component 
                                    :todos="todos"
                                    :type="'contact'"
                                    :fromId="$route.params.id"
                                    @todo-added="addTodo"
                                    @todo-updated="updateTodo"
                                    @todo-deleted="deleteTodo"
                                  />
                              </div>
                          </div>
                      </div>
                  </div>
                  <!-- <button type="button" class="btn btn_black">Apply</button> -->
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import LoaderMaskComponent from "@/components/LoaderMaskComponent.vue";
    import TodoComponent from '@/components/shared/TodoComponent.vue';
    export default {
        name: 'contact-view',
        components: { LoaderMaskComponent, TodoComponent },
        data(){
            return {
              lyLoading: false,
              contact: null,
              activeTab: 'activityList',
              timelines: [],
              tickets: [],
              todos: []
            }
        },
        watch: {
            $route(to, from) {
                if(to.name == from.name && !window._.isEqual(to, from)){
                    this.loadContactData(this.$route.params.id)
                    this.loadTimelineData(this.$route.params.id)
                }
            },
        },
        created() {
            if(this.$route.params.id){
                this.loadContactData(this.$route.params.id)
                this.loadTimelineData(this.$route.params.id)
            }
        },
        mounted(){
          this.ticketScrollbar()
        },
        methods: {
            loadContactData(contactId){
                this.lyLoading = true;
                this.axios.get('/contacts/'+contactId)
                .then((response) => {
                    this.contact = response.data.data
                    this.todos = this.contact.todos
                })
                .catch(() => {
                    this.showFailMsg("No contact exists!");
                })
                .finally(() => {
                    this.ticketScrollbar()
                    this.lyLoading = false;
                })
            },
            loadTimelineData(contactId){
                this.lyLoading = true;
                this.axios.get('/contact-timelines/'+contactId)
                .then((response) => {
                    this.timelines = response.data
                })
                .catch(() => {
                    this.showFailMsg("No timeline exists!");
                })
                .finally(() => {
                    this.lyLoading = false;
                })
            },
            addTodo(newTodo) {
                this.todos.unshift(newTodo);
            },
            updateTodo(updatedTodo) {
                const index = this.todos.findIndex(todo => todo.id === updatedTodo.id);
                if (index !== -1) {
                    this.todos.splice(index, 1, updatedTodo);
                }
            },
            deleteTodo(todoId){
                this.todos = this.todos.filter(todo => todo.id !== todoId);
            }
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style scoped>
  .create_item_tab button {
    position: relative;
    float: right;
    right: 0;
    top: 0;
  }
  .btn_back{
    position: relative;
    float: right;
    right: 0;
    top: 0;
  }
  .font_italic{
    position: relative;
    display: block;
    left: 120px;
    padding-top: 5px;
  }
  .multiselect__tags {
    border-radius: 0;
  }
</style>
